var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { AIEventClassificationModalActions, AIEventClassificationModalData, } from './ai.event.classification.modal.provider';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
var AIEventClassificationModalComponent = /** @class */ (function (_super) {
    __extends(AIEventClassificationModalComponent, _super);
    function AIEventClassificationModalComponent(dialogRef, actions, hubApiService, visitorApiService, imageService, formBuilder, customizationService, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.visitorApiService = visitorApiService;
        _this.imageService = imageService;
        _this.formBuilder = formBuilder;
        _this.customizationService = customizationService;
        _this.events = [];
        _this.customCategories = [];
        _this.isClassifying = false;
        _this.isClassified = false;
        _this.defaultSuggestedCategories = [
            'Adult Preferred',
            'Cultural',
            'Dining Experiences',
            'Family Friendly',
            'Music & Festivals',
            'Live Performance',
            'Sports Competitions',
        ];
        _this.hubName = data.hubName;
        customizationService.getCustomEvent(_this.hubName).subscribe(function (data) {
            _this.customCategories = data.customEvents || [];
            console.log('customCategories', _this.customCategories);
        });
        hubApiService
            .getEvents(_this.hubName, {
            isApproved: true,
            limit: 9999,
            page: 1,
            projection: 'name startTime endTime eventTimes',
        })
            .subscribe(function (events) {
            _this.events = events.map(function (x) {
                return {
                    _id: x._id,
                    name: x.name,
                    categories: [],
                };
            });
        });
        return _this;
    }
    AIEventClassificationModalComponent.prototype.close = function () {
        // if (this.actions.cancel) {
        //   this.actions.cancel();
        // }
        this.dialogRef.close();
    };
    AIEventClassificationModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var categories;
            return __generator(this, function (_a) {
                categories = this.customCategories.map(function (c) { return "\"" + c.btnText + "\""; }).join('; ');
                this.isClassifying = true;
                this.hubApiService
                    .aiAssistant(this.hubName, {
                    query: "The events names are: " + this.events
                        .map(function (x) { return "\"" + x.name + "\""; })
                        .join('; ') + ". The categories are: " + categories + ".",
                    model: 'chatgpt',
                    feature: 'classifyEventsToCustomCategories',
                })
                    .finally(function () {
                    event.complete();
                    _this.isClassifying = false;
                })
                    .subscribe(function (data) {
                    if (data.success) {
                        var json = JSON.parse(data.data);
                        console.log(json);
                        _this.mapEventCategories(json);
                        _this.isClassified = true;
                    }
                    else {
                        alert('Error when classifying!');
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    AIEventClassificationModalComponent.prototype.save = function (event) {
        this.hubApiService
            .bulkClassifyEventCategories(this.hubName, this.events)
            .finally(event.complete)
            .subscribe(function (data) { });
    };
    AIEventClassificationModalComponent.prototype.addCategory = function (event, category) {
        if (this.isClassifying || event.categories.any(function (x) { return x._id === category._id; }))
            return;
        event.categories.push({
            _id: category._id,
            name: category.btnText,
        });
    };
    AIEventClassificationModalComponent.prototype.aiGenerateCategories = function (event) {
        var _this = this;
        this.hubApiService
            .aiAssistant(this.hubName, {
            query: "The events names are: " + this.events.map(function (x) { return "\"" + x.name + "\""; }).join('; ') + ".",
            model: 'chatgpt',
            feature: 'generationEventCategories',
        })
            .finally(function () {
            event.complete();
            _this.isClassifying = false;
        })
            .subscribe(function (data) {
            if (data.success) {
                var json = JSON.parse(data.data);
                console.log(json);
                if (!json['extractedCategories']) {
                    alert('Something went wrong. Please try again.');
                    return;
                }
                _this.customCategories = json['extractedCategories'].map(function (category) {
                    return {
                        btnText: category,
                    };
                });
                _this.mapEventCategories(json);
            }
        });
    };
    AIEventClassificationModalComponent.prototype.removeCategory = function (event, category) {
        event.categories = event.categories.filter(function (x) { return x !== category; });
    };
    AIEventClassificationModalComponent.prototype.mapEventCategories = function (json) {
        var _this = this;
        for (var _i = 0, _a = this.events; _i < _a.length; _i++) {
            var e = _a[_i];
            try {
                if (json.hasOwnProperty(e.name)) {
                    e.categories = json[e.name].map(function (x) {
                        var custom = _this.customCategories.find(function (y) { return y.btnText === x; });
                        return custom
                            ? {
                                _id: custom._id,
                                name: custom.btnText,
                            }
                            : null;
                    });
                    e.categories = e.categories ? e.categories.filter(function (x) { return !!x; }) : [];
                }
            }
            catch (error) {
                console.log(error);
                console.log(e.name);
                console.log(json[e.name]);
            }
        }
    };
    return AIEventClassificationModalComponent;
}(BaseComponent));
export { AIEventClassificationModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/ai.event.classification.modal/ai.event.classification.modal.component.ts.pre-build-optimizer.js